module.exports = __webpack_public_path__ + "static/bg06-cfa7134e76dc3d4cdd92315a58747d33.jpg";